/**
 * Weight units the backend accepts (D-141). Staff enter a value in one of them and the backend
 * keeps it as entered; grams are derived for shipping. Carats are a stone measure, not one of them.
 */
export const WEIGHT_UNITS = ['g', 'kg', 'dwt', 'ozt', 'oz', 'lb'] as const;
export type WeightUnitCode = (typeof WEIGHT_UNITS)[number];

export const GRAMS_PER_WEIGHT_UNIT: Readonly<Record<WeightUnitCode, number>> = {
  g: 1,
  kg: 1000,
  dwt: 1.55517384,
  ozt: 31.1034768,
  oz: 28.349523125,
  lb: 453.59237,
};

/** The backend's `weight_grams` is numeric(10,3). */
export const MAX_WEIGHT_GRAMS = 9_999_999.999;

/** Grams rounded to 3 decimals, exactly as the backend derives `weightGrams`. */
export function toGrams(value: number, unit: WeightUnitCode): number {
  return Math.round(value * GRAMS_PER_WEIGHT_UNIT[unit] * 1000) / 1000;
}

export function isWeightUnit(value: string): value is WeightUnitCode {
  return (WEIGHT_UNITS as readonly string[]).includes(value);
}
